import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'SelectTree',
  props: {
    value: String,
    data: Array,
    clearable: Boolean,
    filterable: Boolean,
    fieldNames: {
      type: Object,
      default: function _default() {
        return {
          id: 'id',
          label: 'label',
          children: 'children',
          key: 'key'
        };
      }
    },
    nodeKey: {
      type: String,
      default: 'key'
    }
  },
  data: function data() {
    return {
      selectValue: undefined
    };
  },
  computed: {
    elTreeProps: function elTreeProps() {
      var _this$fieldNames = this.fieldNames,
        label = _this$fieldNames.label,
        children = _this$fieldNames.children;
      return {
        label: label,
        children: children
      };
    }
  },
  methods: {
    handleFilterNode: function handleFilterNode(value, data) {
      if (!value) return true;
      return data[this.fieldNames.label].indexOf(value) !== -1;
    },
    handleFilterMethod: function handleFilterMethod(value) {
      var _this = this;
      this.$nextTick(function () {
        _this.$refs.ElTree.filter(value);
      });
    },
    handleVisibleChange: function handleVisibleChange(visibled) {
      if (this.filterable && visibled) {
        this.handleFilterMethod(this.selectValue);
      }
    },
    handleClear: function handleClear() {
      this.selectValue = undefined;
      this.$refs.ElTree.setCurrentKey(null);
      this.$emit('input', undefined);
    },
    handleNodeClick: function handleNodeClick(data) {
      this.selectValue = data[this.fieldNames.label];
      this.$emit('input', data[this.nodeKey]);
      this.$refs.ElSelect.blur();
    }
  }
};